import { Metadata } from '@redwoodjs/web';

import StatusStepper, { financialEntityStatuses } from 'src/components/atoms/StatusStepper';
import { PageBody } from 'src/components/containers/PageBody';
import { PageHeader, PageType } from 'src/components/containers/PageHeader';
import SkeletonDataGrid from 'src/components/containers/skeleton/SkeletonDataGrid';
import SkeletonEntryForm from 'src/components/containers/skeleton/SkeletonEntryForm';
import SkeletonStepper from 'src/components/containers/skeleton/SkeletonStepper';
import { AgCollapsibleCard } from 'src/components/ui';
import useCustomerPortalPurchaseOrder from '../purchase-order/useCustomerPortalPurchaseOrder';
import DownloadInvoice from './DownloadInvoice';
import InvoiceCredits from './InvoiceCredits';
import InvoiceDetails from './InvoiceDetails';
import OrderDetails from './OrderDetails';
import OrderExpenses from './OrderExpenses';
import OrderProducts from './OrderProducts';
import useCustomerPortalInvoice from './useCustomerPortalInvoice';

export const financialStatusesSansDraft = financialEntityStatuses.filter((status) => status !== 'DRAFT');

export default function ViewCustomerPortalInvoicePage({ slug }) {
  const invoice = useCustomerPortalInvoice(slug);
  const purchaseOrder = useCustomerPortalPurchaseOrder(invoice?.orderSlug);

  return (
    <>
      <Metadata title={`Invoice #${slug}`} />
      <PageHeader pageType={PageType.CustomerPortalInvoice} entitySlug={slug}>
        <div className="grow" />
        <DownloadInvoice />
      </PageHeader>
      <PageBody sx={{ flexDirection: 'column', gap: 2 }}>
        {invoice ? (
          <>
            <StatusStepper allStatuses={financialStatusesSansDraft} currentStatus={invoice.status} />
            <InvoiceDetails invoice={invoice} />
            <InvoiceCredits invoice={invoice} />
          </>
        ) : (
          <Skeleton stepper />
        )}
        {invoice && purchaseOrder ? (
          <>
            <OrderDetails purchaseOrder={purchaseOrder} />
            <OrderProducts purchaseOrder={purchaseOrder} />
            <OrderExpenses invoice={invoice} />
          </>
        ) : (
          <Skeleton />
        )}
      </PageBody>
    </>
  );
}

function Skeleton({ stepper }: { stepper?: boolean }) {
  return (
    <>
      {stepper && <SkeletonStepper allStatuses={financialStatusesSansDraft} />}
      <AgCollapsibleCard title="">
        <SkeletonEntryForm fields={6} />
      </AgCollapsibleCard>
      <AgCollapsibleCard title="">
        <SkeletonDataGrid
          columns={{ a: {}, b: {}, c: {} }}
          rowCount={3}
          gridKey="customer-portal.invoice.skeleton"
          storageKey="skele"
        />
      </AgCollapsibleCard>
    </>
  );
}
